import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-not-created',
    templateUrl: './not-created.component.html',
    styleUrls: ['../../login.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotCreatedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
